import React, { useEffect, useState } from 'react';
import useCampaignStore from './store/orderstore';
import Select from 'react-select';
import './kanbanStylesModernWhiteContent.css';

const statuses = [
  'Yet to Start',
  'Order Accepted',
  'Design',
  'Printed',
  'Lamination Mounting Packing',
  'Delivered',
  'Implemented',
  'Proof of Execution'
];
const statusColors = {
  'Yet to Start': '#FFE7BA',
  'Order Accepted': '#D9F7BE',
  'Design': '#D6E4FF',
  'Printed': '#FFF1B8',
  'Lamination Mounting Packing': '#CCDE33',
  'Delivered': '#E6F7FF',
  'Implemented': '#FFD6E7',
  'Proof of Execution': '#F6FFED'
};
const mapStatusToGroup = (status) => {
  if (['Packing', 'Lamination', 'Mounting'].includes(status)) {
    return 'Lamination Mounting Packing';
  }
  return status;
};
const inProgressStatuses = [
  'Order Accepted',
  'Design',
  'Printed',
  'Packing',
  'Delivered'
];

const KanbanView = () => {
  const { campaigns, fetchCampaigns } = useCampaignStore();
  const [filters, setFilters] = useState({ brand: '', category: '', campaign: '' });
  const [groupByLocation, setGroupByLocation] = useState(false);
  const [expandedLocations, setExpandedLocations] = useState({});
  const [previewImage, setPreviewImage] = useState(null);

  useEffect(() => {
    fetchCampaigns();

    const intervalId = setInterval(() => {
      fetchCampaigns();
    }, 120000); // 2 minutes

    return () => clearInterval(intervalId);
  }, [fetchCampaigns]);

  

//   const allItems = campaigns.flatMap(campaign =>
//   campaign.items.flatMap(item => {
//     const normalizedStatus = mapStatusToGroup(item.status?.trim() || 'Yet to Start');

//     const base = {
//       ...item,
//       campaignId: campaign.id,
//       campaignName: campaign.campaignName || campaign.name || 'Untitled'
//     };

//     return [
//       { ...base, status: normalizedStatus }, // Actual status
//       { ...base, status: 'Yet to Start', _duplicatedForStart: true } // Force extra appearance in Yet to Start
//     ];
//   })
// );

const allItems = campaigns.flatMap(campaign =>
  campaign.items.map(item => {
    const rawStatus = item.status?.trim();
    const normalizedStatus = mapStatusToGroup(rawStatus || 'Yet to Start');

    return {
      ...item,
      status: normalizedStatus,
      campaignId: campaign.id,
      campaignName: campaign.campaignName || campaign.name || 'Untitled'
    };
  })
);


  const getOptions = (key) => {
    const values = Array.from(new Set(allItems.map(item => item[key]).filter(Boolean)));
    return values.map(v => ({ label: v, value: v }));
  };


const getPdfUrl = (item) =>
  item?.pdfurl || item?.pdfUrl || item?.PdfUrl || item?.['PDF URL'] || null;



  const filteredItems = allItems.filter(item =>
    (!filters.brand || item['Brand name'] === filters.brand) &&
    (!filters.category || item['Cataegeory'] === filters.category) &&
    (!filters.campaign || item.campaignName === filters.campaign)
  );

  const hasAcceptedOrBeyond = filteredItems.some(item => {
  const currentStatus = mapStatusToGroup(item.status?.trim() || 'Yet to Start');
  return statuses.indexOf(currentStatus) > statuses.indexOf('Yet to Start');
});

  const toggleLocation = (status, location) => {
    const key = `${status}-${location}`;
    setExpandedLocations(prev => ({ ...prev, [key]: !prev[key] }));
  };

  return (
    <>
      <div style={{ padding: '20px' }}>
        <div style={{ display: 'flex', gap: '1rem', marginBottom: '1rem', flexWrap: 'wrap', alignItems: 'center' }}>
          <Select
            placeholder="Filter by Brand"
            options={getOptions('Brand name')}
            isClearable
            value={filters.brand ? { label: filters.brand, value: filters.brand } : null}
            onChange={(selected) => setFilters(prev => ({ ...prev, brand: selected?.value || '' }))}
            styles={{ container: base => ({ ...base, width: 200 }) }}
          />
          <Select
            placeholder="Filter by Category"
            options={getOptions('Cataegeory')}
            isClearable
            value={filters.category ? { label: filters.category, value: filters.category } : null}
            onChange={(selected) => setFilters(prev => ({ ...prev, category: selected?.value || '' }))}
            styles={{ container: base => ({ ...base, width: 200 }) }}
          />
          <Select
            placeholder="Filter by Campaign"
            options={getOptions('campaignName')}
            isClearable
            value={filters.campaign ? { label: filters.campaign, value: filters.campaign } : null}
            onChange={(selected) => setFilters(prev => ({ ...prev, campaign: selected?.value || '' }))}
            styles={{ container: base => ({ ...base, width: 200 }) }}
          />
          <label style={{ display: 'flex', alignItems: 'center', gap: '8px', fontWeight: 'bold' }}>
            <input
              type="checkbox"
              checked={groupByLocation}
              onChange={() => setGroupByLocation(prev => !prev)}
            />
            Group by Location
          </label>
          <button
            onClick={fetchCampaigns}
            style={{
              padding: '8px 12px',
              backgroundColor: '#1890ff',
              border: 'none',
              borderRadius: '4px',
              color: 'white',
              fontWeight: 'bold',
              cursor: 'pointer'
            }}
          >
            Refresh Now
          </button>
        </div>

        <div style={{ display: 'flex', gap: '0rem', alignItems: 'stretch' }}>
          {statuses.map((status, index) => {
//             const itemsByStatus = filteredItems.filter(item => {
//   if (status === 'Lamination Mounting Packing') {
//     return ['Lamination', 'Mounting', 'Packing'].includes(item.status);
//   }
//   return item.status === status;
// });
const itemsByStatus = filteredItems.filter(item => item.status === status);


            if (!groupByLocation) {
              return (
                <React.Fragment key={status}>
                  <div
                    className="kanban-column" data-status={status} 
                    style={{
                      backgroundColor: '#ffffff',
                      padding: '10px',
                      borderRadius: '8px',
                      minHeight: 400,
                      border: '2px solid #999',
                      overflowY: 'auto',
                      position: 'relative'
                    }}
                  >
                    <h3 style={{ textAlign: 'center' }}>
  {status === 'Yet to Start' && hasAcceptedOrBeyond ? 'Requisition from Loreal' : status}
</h3>
                    {itemsByStatus.map((item, idx) => (
                      <React.Fragment key={item.id || item._id || JSON.stringify(item)}>
                        <div
                          className={`kanban-card ${
                            (item['Brand name'] || item['Cataegeory'] || item.campaignName || item['Location'] || item['Recce Images'] || item.implementImage)
                              ? 'blinking' : ''
                          }`}
                          style={{
                            marginBottom: '10px',
                            padding: '10px',
                            borderRadius: '6px',
                            boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
                          }}
                        >
                          <p><strong>{item['Brand name']}</strong></p>
                          <p>{item['Cataegeory']} | Qty: {item['QTY']}</p>
                          <p><small>Campaign: {item.campaignName}</small></p>
                          <p><strong>Location:</strong> {item['Location']}</p>

                          {item['Recce Images'] && (
                            <img
                              src={item['Recce Images']}
                              alt="Recce" className="card-image"
                              style={{
                                width: '100%',
                                maxHeight: 100,
                                objectFit: 'cover',
                                borderRadius: 4,
                                marginTop: 5
                              }}
                            />
                          )}

                          {item.implementImage && (
                            <div style={{ marginTop: 5 }}>
                              <strong>Implemented Image:</strong>
                              <img
                                src={item.implementImage}
                                alt="Implemented" className="card-thumbnail"
                                style={{
                                  width: 60,
                                  height: 60,
                                  objectFit: 'cover',
                                  borderRadius: 4,
                                  marginTop: 4,
                                  cursor: 'zoom-in'
                                }}
                                onClick={() => setPreviewImage(item.implementImage)}
                              />
                           
</div>



                            
                          )}
                          {console.log('Image URL:', item)}
                              {item.ImageURL && (
  <div style={{ marginTop: 5 }}>
    <strong>Image URL:</strong>
    <img
      src={item.ImageURL}
      alt="Image URL Preview"
      style={{
        width: 60,
        height: 60,
        objectFit: 'cover',
        borderRadius: 4,
        marginTop: 4,
        cursor: 'zoom-in'
      }}
      onClick={() => setPreviewImage(item.ImageURL)}
    />
  </div>
)}

{getPdfUrl(item) && (
  <div style={{ marginTop: 8 }}>
    <strong>Job PDF:</strong>{' '}
    <a
      href={getPdfUrl(item)}
      target="_blank"
      rel="noopener noreferrer"
      style={{
        color: '#1890ff',
        fontWeight: 'bold',
        textDecoration: 'underline',
        cursor: 'pointer'
      }}
    >
      View PDF
    </a>
  </div>
)}
                            
                        </div>

                        {idx < itemsByStatus.length - 1 && (
                          <div style={{ fontSize: 20, textAlign: 'center', color: '#555' }}>↓</div>
                        )}
                      </React.Fragment>
                    ))}
                  </div>

                  {index < statuses.length - 1 && (
                    <div style={{
                      fontSize: 32,
                      alignSelf: 'center',
                      color: '#666'
                    }}>→</div>
                  )}
                </React.Fragment>
              );
            }

            const groupedByLocation = itemsByStatus.reduce((acc, item) => {
              const loc = item.Location || 'Unknown';
              acc[loc] = acc[loc] || [];
              acc[loc].push(item);
              return acc;
            }, {});

            return (
              <React.Fragment key={status}>
                <div
                  style={{
                    flex: 1,
                    backgroundColor: statusColors[status],
                    padding: '10px',
                    borderRadius: '8px',
                    minHeight: 400,
                    border: '2px solid #999',
                    overflowY: 'auto'
                  }}
                >
                  <h3 style={{ textAlign: 'center' }}>{status}</h3>
                  {Object.entries(groupedByLocation).map(([location, items]) => {
                    const locKey = `${status}-${location}`;
                    const isOpen = expandedLocations[locKey];

                    return (
                      <div key={locKey} style={{ marginBottom: '1rem' }}>
                        <h5
                          onClick={() => toggleLocation(status, location)}
                          className="location-toggle"
                        >
                          {isOpen ? '▼' : '▶'} {location} ({items.length})
                        </h5>
                        {isOpen &&
                          items.map(item => (
                            <div
                              key={item.id || item._id || JSON.stringify(item)}
                              className={`kanban-card ${
                                (item['Brand name'] || item['Cataegeory'] || item.campaignName || item['Location'] || item['Recce Images'] || item.implementImage)
                                  ? 'blinking' : ''
                              }`}
                              style={{
                                backgroundColor: '#fff',
                                marginBottom: '10px',
                                padding: '10px',
                                borderRadius: '6px',
                                boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
                              }}
                            >
                              <p><strong>{item['Brand name']}</strong></p>
                              <p>{item['Cataegeory']} | Qty: {item['QTY']}</p>
                              <p><small>Campaign: {item.campaignName}</small></p>

                              {item['Recce Images'] && (
                                <img
                                  src={item['Recce Images']}
                                  alt="Recce" className="card-image"
                                  style={{
                                    width: '100%',
                                    maxHeight: 100,
                                    objectFit: 'cover',
                                    borderRadius: 4,
                                    marginTop: 5
                                  }}
                                />
                              )}
                            </div>
                          ))}
                      </div>
                    );
                  })}
                </div>

                {index < statuses.length - 1 && (
                  <div style={{
                    fontSize: 32,
                    alignSelf: 'center',
                    color: '#666'
                  }}>→</div>
                )}
              </React.Fragment>
            );
          })}
        </div>
      
       {previewImage && (
  <div
    onClick={() => setPreviewImage(null)}
    style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0,0,0,0.85)',
      zIndex: 9999,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '10px'
    }}
  >
    <div
      onClick={(e) => e.stopPropagation()}
      style={{
        position: 'relative',
        background: '#fff',
        borderRadius: '8px',
        maxWidth: '98vw',
        maxHeight: '98vh',
        overflow: 'hidden',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
      }}
    >
      <img
        src={previewImage}
        alt="Zoom"
        style={{
          maxWidth: '95vw',
          maxHeight: '95vh',
          objectFit: 'contain',
          borderRadius: '4px',
          cursor: 'zoom-out',
          display: 'block',
          margin: 'auto'
        }}
      />
      <button
        onClick={() => setPreviewImage(null)}
        style={{
          position: 'absolute',
          top: 10,
          right: 10,
          padding: '6px 10px',
          backgroundColor: '#dc3545',
          color: 'white',
          border: 'none',
          borderRadius: '4px',
          cursor: 'pointer',
          fontWeight: 'bold'
        }}
      >
        ✕ Close
      </button>
    </div>
  </div>
)}
      </div>
    </>
  );
};

export default KanbanView;
